import { diInject } from "stores/diContext";

import { observable, computed } from "mobx";

import { EventStore } from "./events";
import { EventService } from "../services/events";
import { TicketItemStore } from "./ticket";
import { OrderStore } from "Apps/ticketing/stores/order";

import { reCaptchaExecute } from "recaptcha-v3-react-function-async";

class CartItem {
  @diInject() orderStore: OrderStore;
  constructor(public ticketStore: TicketItemStore) {}

  quantity = 0;
  add(count = 1) {
    for (let i = 0; i < count; i++) {
      this.quantity += 1;
      this.orderStore.attendees.add(this.ticketStore.ticket);
    }

    return this.quantity;
  }
  remove(count) {
    for (var i = 0; i < count; i++) {
      this.quantity -= 1;
      this.orderStore.attendees.remove(this.ticketStore.id);
    }
    return this.quantity;
  }
}

export class CartStore {
  @diInject() eventStore: EventStore;
  @diInject() eventService: EventService;
  payment_method = "StripeTokenDirect";
  @observable discounts = [];
  items = observable.map<CartItem>({});
  donations = observable.map<{ id; amount }>({});

  @computed get total_doantion_amount() {
    var amount = 0;
    var donations = this.donations.values();
    donations.forEach((donation) => {
      amount += donation.amount;
    });
    return amount;
  }

  @computed get raw_total_amount() {
    var cartItems = this.items.values();
    var amount = 0;
    cartItems.forEach((item) => {
      amount += item.ticketStore.raw_total_amount;
    });
    return amount + this.total_doantion_amount;
  }

  @computed get total_amount() {
    var cartItems = this.items.values();
    var amount = 0;
    cartItems.forEach((item) => {
      amount += item.ticketStore.total_amount;
    });
    return amount + this.total_doantion_amount;
  }

  @computed get can_checkout() {
    const items = this.items.values();
    const donations = this.donations.values();
    if (this.total_amount > __MAX_ORDER_AMOUNT__) {
      return false;
    }
    if (items.length == 0 && donations.length == 0) {
      return false;
    }
    return true;
  }

  @computed get only_donation() {
    return this.items.size == 0;
  }

  @computed get allCount() {
    var count = 0;
    const items = this.items.values();
    this.items.forEach((item) => {
      count += item.quantity;
    });
    return count;
  }

  donation(id, amount) {
    if (amount > 0) {
      this.donations.set(id, { id, amount });
    } else {
      this.donations.delete(id);
    }
  }

  addTicket(itemStore: TicketItemStore) {
    // var { ticket, ticket: { id } } = itemStore;
    var { id } = itemStore;

    if (!this.items.has(id)) {
      this.items.set(id, new CartItem(itemStore));
    }
    var cartItem = this.items.get(id);
    return cartItem.add();
  }

  updateTicket(itemStore: TicketItemStore, count = 1) {
    const { id } = itemStore;
    this.items.set(id, new CartItem(itemStore));
    const cartItem = this.items.get(id);

    return cartItem.add(count);
  }

  removeTicket(id, count = 1) {
    let quantity = 0;
    if (this.items.has(id)) {
      var cartItem = this.items.get(id);
      quantity = cartItem.remove(count);
      if (quantity == 0) {
        this.items.delete(id);
      }
    }
    return quantity;
  }

  clear() {
    this.discounts = [];
    this.items.clear();
    this.donations.clear();
  }
  async applyPromoCode(codeStr) {
    //const gtoken = await reCaptchaExecute(process.env.reCaptchaKey, 'auth');
    const gtoken = "";

    codeStr = codeStr.replace(/(^\s*)|(\s*$)/g, "");
    if (!/^[A-z0-9-+]{1,128}$/.test(codeStr)) {
      return false;
    }
    const event_id = this.eventStore.event.id;
    const codes: Array<any> = await this.eventService.getPromoCode(
      event_id,
      codeStr,
      this.payment_method,
      gtoken
    );
    if (codes.length == 0) {
      return false;
    }
    const ticketItemStores = this.eventStore.ticketsStore.tickets;
    const maps: { [key: string]: TicketItemStore } = {};
    for (let ticketItemStore of ticketItemStores) {
      ticketItemStore.clearPromoCode();
      maps[`t_${ticketItemStore.id}`] = ticketItemStore;
    }
    var apply_discounts = [];
    var apply_discount_success = true;
    for (let code of codes) {
      let applied_to_tickets = code.applied_to_tickets;
      apply_discounts.push(code.id);
      for (let ticket of applied_to_tickets) {
        let store = maps[`t_${ticket.id}`];
        if (store) {
          if (!store.applyPromoCode(code, ticket)) {
            apply_discount_success = false;
            break;
          }
        }
      }
      if (!apply_discount_success) {
        break;
      }
    }
    if (apply_discount_success) {
      this.discounts = apply_discounts;
      return true;
    } else {
      this.clearPromoCode();
      throw { error: { code: 800011 } };
    }
  }
  /**
   * @param code
   */
  async applyPromoCodeNew(codeStr, gtoken) {
    codeStr = codeStr.replace(/(^\s*)|(\s*$)/g, "");

    if (!/^[A-z0-9-+.]{1,128}$/.test(codeStr)) {
      return false;
    }

    const event_id = this.eventStore.event.id;
    const codes: Array<any> = await this.eventService.getPromoCode(
      event_id,
      codeStr,
      this.payment_method,
      gtoken
    );

    if (codes.length == 0) {
      return false;
    }

    const ticketItemStores = this.items.values().map((el) => el.ticketStore);

    const maps: { [key: string]: TicketItemStore } = {};

    for (let ticketItemStore of ticketItemStores) {
      ticketItemStore.clearPromoCode();

      maps[`t_${ticketItemStore.id}`] = ticketItemStore;
    }

    let apply_discounts = [];
    let apply_discount_success = false;

    for (let code of codes) {
      let applied_to_tickets = code.applied_to_tickets;

      apply_discounts.push(code.id);
      for (let ticket of applied_to_tickets) {
        let store = maps[`t_${ticket.id}`];

        if (store) {
          if (store.applyPromoCode(code, ticket)) {
            apply_discount_success = true;
          }
        }
      }
    }

    if (apply_discount_success) {
      this.discounts = apply_discounts;
      return true;
    } else {
      this.clearPromoCode();
      throw { error: { code: 800012 } };
    }
  }

  clearPromoCode() {
    for (var store of this.eventStore.ticketsStore.tickets) {
      store.clearPromoCode();
    }
  }
}

export default CartStore;



// WEBPACK FOOTER //
// ./src/Apps/ticketing/stores/cart.ts